import { render, staticRenderFns } from "./MiddleName.vue?vue&type=template&id=4ea47d03&scoped=true&"
import script from "./MiddleName.vue?vue&type=script&lang=js&"
export * from "./MiddleName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea47d03",
  null
  
)

export default component.exports